/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum SubmissionsStatusFilterEnum {
  NotStarted = 'not_started',
  Pending = 'pending',
  Completed = 'completed'
}
